import React from 'react';
import css from './css.module.less';
import Pricing from '../../Components/Pricing/Pricing1';
import { useDispatch, useSelector } from 'react-redux';
import {
  onAdvancedPriceChange,
  onPriceChange,
  onAdvancedPriceAdd,
  onCollapseChange,
  getCollapse,
  EnumCollapseId,
  getAdvancedPriceSettings,
  getPriceSettings,
} from '../slice';
import { EditIcon } from '@/src/components/EditableTable/EditableTable';
import {
  TableInput,
  //TableSelect,
  TableNumberInput,
} from 'src/components/EditableTable/TableForm/TableForm';
import { EnumTablePosition } from 'src/types/common/common';
//import { EnumMode } from '@/src/components/Antd/NumberInput/NumberInput';
import SectionHOC from '../HOC';
import { EnumIds } from 'src/pages/ProductEditor/VirtualProduct/common';
import { getCurrencies } from '@/src/constrains/GlobalProvider/slice';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { isNumber } from 'src/tools/helper';
import { useI18n } from 'src/hooks/useRouterChange';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';
const PricingSection = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { productUuid, disabled } = props;
  const priceSettings = useSelector(getPriceSettings());
  const currencies = useSelector(getCurrencies());
  const advancedPriceSettings = useSelector(getAdvancedPriceSettings()) || [];

  const advancedPriceSettingsOpen = useSelector(
    getCollapse(EnumCollapseId['sub-advancedPriceSettingsOpen']),
  );
  const dispatch = useDispatch();
  const priceSettingsOnChange = (data) => {
    dispatch(onPriceChange(data));
  };
  const advancedPriceSettingsOnChange = (isDelete, index, settings) => {
    dispatch(
      onAdvancedPriceChange({
        isDelete,
        index,
        settings,
      }),
    );
  };
  const advancedPriceSettingsAddNew = () => {
    dispatch(onAdvancedPriceAdd());
  };
  const advancedPriceSettingsColOpen = (e) => {
    dispatch(
      onCollapseChange({
        id: EnumCollapseId['sub-advancedPriceSettingsOpen'],
        status: e,
      }),
    );
  };
  const advancedOnChange = (index, setting) => {
    if (advancedPriceSettingsOnChange)
      advancedPriceSettingsOnChange(false, index, setting);
  };
  const columns = React.useMemo(() => {
    return [
      {
        title: () => <React.Fragment />,
        key: 'index',
        childGenerate: (text, record, index) => {
          return <span>{index + 1}</span>;
        },
        width: 40,
        default: true,
      },
      {
        title: () => (
          <div className={css.firstHeader}>
            <span>
              {getI18n(
                'allProducts.addproductset.pricing_ProductionSetPricingSection_price_Tier',
              )}
            </span>
          </div>
        ),
        key: 'title',
        childGenerate: (text, record, index) => {
          const { title = '-' } = record;
          return (
            <NoWrapContainer>
              <Tooltip title={title}>{title}</Tooltip>
            </NoWrapContainer>
          );
        },
        minWidth: 420,
        default: true,
      },
      {
        title: () => (
          <div className={css.fontbackHeader}>
            <EditIcon />
            <span>{getI18n('allProducts.addproductset.price')}</span>
          </div>
        ),
        position: EnumTablePosition.right,
        childGenerate: (text, record, index) => {
          const { price, priceError } = record;
          return (
            <TableNumberInput
              label={isNumber(price) ? price.toFixed(2) : '-'}
              precision={2}
              error={priceError}
              rightPosition
              value={price}
              disabled={disabled}
              onChange={(e) => {
                advancedOnChange(index, { price: e });
              }}
            />
          );
        },
        key: 'price',
        minWidth: 144,
        default: true,
      },
      {
        title: () => (
          <div className={css.fontbackHeader}>
            <span>{getI18n('general.currency')}</span>
          </div>
        ),
        position: EnumTablePosition.right,
        childGenerate: (text, record, index) => {
          const { currencyCode = '-' } = record;
          return (
            <NoWrapContainer>
              <Tooltip title={currencyCode}>{currencyCode}</Tooltip>
            </NoWrapContainer>
          );
        },
        key: 'currency',
        minWidth: 144,
        default: true,
      },
      {
        title: () => (
          <div>
            <EditIcon />
            <span>{getI18n('general.notes')}</span>
          </div>
        ),

        childGenerate: (text, record, index) => {
          const { notes, notesError } = record;
          return (
            <TableInput
              maxLength={500}
              error={notesError}
              value={notes}
              disabled={disabled}
              onChange={(e) => {
                advancedOnChange(index, { notes: e });
              }}
            />
          );
        },
        key: 'notes',
        minWidth: 412,
        default: true,
      },
    ];
  }, [advancedPriceSettings, currencies]);

  return (
    <Pricing
      disabled={disabled}
      productUuid={productUuid}
      ids={EnumIds}
      columns={columns}
      priceSettings={priceSettings}
      advancedPriceSettings={advancedPriceSettings}
      priceSettingsOnChange={priceSettingsOnChange}
      advancedPriceSettingsOnChange={advancedPriceSettingsOnChange}
      advancedPriceSettingsAddNew={advancedPriceSettingsAddNew}
      advancedPriceSettingsOpen={advancedPriceSettingsOpen}
      setAdvancedPriceSettingsOpen={advancedPriceSettingsColOpen}
    />
  );
};
export default SectionHOC(PricingSection, {
  useDefaultCollapseContent: true,
  title: getI18nFromGeneral('general.hOCTitle.pricing'),
  id: EnumCollapseId.Pricing,
});
